import React from 'react';


var Containers = {

	getContainerDisplay : function(stateVar, dataFunction, additionalInfo) {
		var addParam = (additionalInfo && additionalInfo.addParam) ? additionalInfo.addParam : '';
		if(stateVar.dataError === false && stateVar.data !== null && Object.keys(stateVar.data).length === 0) {
			return (
				<div className="App-LoadContainer"><div className="App-Loader"></div><div className="Loading">Gathering data...</div></div>
			);
		}
		else if (stateVar.dataError === false && stateVar.data !== null && Object.keys(stateVar.data).length > 0) {
			//real chart data!
			if (additionalInfo && additionalInfo.key) return dataFunction(stateVar.data[additionalInfo.key], addParam);
			return dataFunction(stateVar.data, addParam);
		}
		
		return (

			<div className='Data-Error'>Data Load Failed.</div>
		);
	}
}

export default Containers;